/**
 * Redux middleware that persists theme mode to localStorage on every action.
 * Access token is intentionally NOT persisted here (stays in Redux memory only — XSS safe).
 * Refresh token persists via HttpOnly cookie managed by the browser.
 */
export const localStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const state = store.getState();

  if (action.type.startsWith('theme/')) {
    localStorage.setItem('theme', state.theme.mode);
  }

  return result;
};
